<template>
    <ClientOnly>
        <LazyModalsVideoModal v-if="isClientReady" />
        <LazyModalsFeedbackModal v-if="isClientReady" />
        <LazyModalsSuccessModal v-if="isClientReady" />
    </ClientOnly>
</template>

<script setup lang="ts">
const isClientReady = ref(false)

onMounted(() => {
    isClientReady.value = true
})
</script>
